/*
Обязательные классы и атрибуты: i-sort-list, i-sort-list__op, _selected, data-value

Опционально можно создать элемент с направлением сортировки i-sort-list__double
Тогда необходимо указать ему data-current со значением "down" или "up", data-value-down и data-value-up со значениями
при соответствующей направлении сортировки
-----------------------------------------
События пример:
$(document).on('is:change', '.catalog-sort', function (e, val) {
    console.log(val);
})
-----------------------------------------
Пример:
<div class="i-sort-list catalog-sort">
    <button class="i-sort-list__op _selected" data-value="new">
        По новинкам
    </button>
    <button class="i-sort-list__op" data-value="popular">
        По популярности
    </button>
    <button class="i-sort-list__double" data-current="down" data-value-down="priceDown" data-value-up="priceUp">
        По цене
    </button>
</div>
-----------------------------------------
Для позиционирования и кастомизации обернуть в контейнер
*/



(function () {
    $(function () {
        $('.i-sort-list').each(function () {
            const $list = $(this);
            const $option = $list.find('.i-sort-list__op');
            const $double = $list.find('.i-sort-list__double');
        
            // Нажатие на единичный пункт
            $option.on('click', function (e) {
                e.preventDefault();
                const $target = $(this);
            
                if (!$target.hasClass('_selected')) {
                    $target.addClass('_selected').siblings().removeClass('_selected');
                    //------------------------
                    $list.trigger('is:change', $target.data('value'));
                }
            });
    
            // Нажатие на пункт с направлением сортировки
            $double.on('click', function (e) {
                e.preventDefault();
                const $target = $(this);
                let sortDir = $target.attr('data-current');
            
                if ($target.hasClass('_selected')) {
                    if (sortDir === 'down') {
                        sortDir = 'up';
                    } else if (sortDir === 'up') {
                        sortDir = 'down';
                    }
                    $target.attr('data-current', sortDir);
                } else {
                    $target.addClass('_selected').siblings().removeClass('_selected');
                }
            
                //------------------------
                $list.trigger('is:change', $target.data('value-' + sortDir));
            })
        });
    })
}());
